// Types
import { ReducableAction, FeatureToggle, FeatureToggleState } from 'types'

// Utils
import { FEATURE_TOGGLES } from '@constants'

const mergeFeatureToggles = (
  featureToggleList: Array<FeatureToggle>,
): {
  [id: string]: FeatureToggle
} =>
  featureToggleList.length
    ? featureToggleList.reduce(
        (agg, ft) => ({
          ...agg,
          [ft.feature_name]: ft,
        }),
        {},
      )
    : {}

const reducer = (state: FeatureToggleState = mergeFeatureToggles(FEATURE_TOGGLES), action: ReducableAction) => {
  switch (action.type) {
    case 'FETCH_FEATURE_TOGGLES_DONE':
      return mergeFeatureToggles(action.data.response.results)
    default:
      return state
  }
}

export default reducer
